module.exports = "/images/vendor/vue-paycard/src/aura.png?65e73ee1dbffd48db490d71d612bab23";